import { sceneStateHelper } from '../ThreeJsUtils/SceneStateHelper';
import { refreshAnimationTransformAnchors } from '../ThreeJsUtils/syncObjectTransform';
import { resetAnimationsToOriginalState } from '../ThreeJsUtils/applyAnimations';
import { stopPreviewTimelinePlayback } from './startAllSceneAnimations';

/** Put animated objects back on their design rest pose (originalPosition anchors). */
export function restoreAnimationRestPoses(scene) {
  if (!scene) return;
  scene.traverse((obj) => {
    if (!obj?.userData?.originalPosition) return;
    try {
      obj.position.copy(obj.userData.originalPosition);
      if (obj.userData.originalRotation) {
        obj.rotation.copy(obj.userData.originalRotation);
      }
      if (obj.userData.originalScale) {
        obj.scale.copy(obj.userData.originalScale);
      }
      refreshAnimationTransformAnchors(obj);
      obj.updateMatrix();
      obj.updateMatrixWorld(true);
    } catch (_) {}
  });
}

/**
 * Stop timeline / preview animation loops and restore design transforms
 * so publish/save collects authored poses — not mid-scrub or mid-preview.
 */
export function prepareSceneTransformsForPublish({
  scene,
  animationObjects = [],
  completeObject = null,
} = {}) {
  if (!scene) return;

  // 1) Stop shared preview clock + any registered RAF loops
  stopPreviewTimelinePlayback();
  if (typeof completeObject?.stopAllAnimations === 'function') {
    completeObject.stopAllAnimations();
  }

  if (typeof window !== 'undefined') {
    window.__timelinePlaybackActive = false;
    window.__timelinePlaybackPaused = false;
    // Design timeline panel: stop loops without wiping capture/rest data
    try {
      window.dispatchEvent(new CustomEvent('stopTimelinePlayback'));
    } catch (_) {}
  }

  // 2) Prefer snapshot taken when entering preview; otherwise use animation anchors
  if (sceneStateHelper.hasSavedStates()) {
    sceneStateHelper.restoreStates(scene);
  } else {
    restoreAnimationRestPoses(scene);
  }

  // 3) Stop playModel/GLB actions and restore materials without fighting restored transforms
  if (Array.isArray(animationObjects) && animationObjects.length > 0) {
    resetAnimationsToOriginalState(scene, animationObjects, {
      restoreTransforms: false,
      restoreMaterials: true,
    });
  }
}
